/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'goal-content.goal-about-content.description-edit-button': '編集',
  'project-actions.project-content-about.edit-description-error-description':
    '問題が発生しました。しばらくしてから再度お試しください。',
  'project-content.project-content-about.edit-description-error-title': 'プロジェクトの説明を編集できませんでした',
  'project-content.project-content-about.the-measure-placeholder':
    '成功とはどのような状態か、また達成したい目標について説明します。',
  'project-content.project-content-about.the-measure-title': '成功の判断基準',
  'project-content.project-content-about.the-what-placeholder':
    'このプロジェクトの概要と、それに伴う作業の内容について説明します。',
  'project-content.project-content-about.the-what-title': 'プロジェクトで達成すること',
  'project-content.project-content-about.the-why-placeholder':
    'この作業を行う背景や、その動機、目的について説明します。',
  'project-content.project-content-about.the-why-title': 'プロジェクトを実行する理由',
  'project-content.project-content-update-date.edited': '(編集済み)',
  'project-content.project-content-update-date.edited-tooltip': '編集日: {date}',
  'project-content.project-content-update-date.last-edited-by': '(最終編集者: {name})',
  'project-content.project-content-updates.add-update': '最新情報を追加',
  'project-content.project-content-updates.archived': 'アーカイブ済み',
  'project-content.project-content-updates.at-risk': 'リスクあり',
  'project-content.project-content-updates.cancelled': 'キャンセル済み',
  'project-content.project-content-updates.completed': '完了 🎉',
  'project-content.project-content-updates.date-changed': '日付が変更されました',
  'project-content.project-content-updates.edit-update': '編集',
  "project-content.project-content-updates.for-date'": ': {dueDate}',
  'project-content.project-content-updates.latest-update-title': '前回更新',
  'project-content.project-content-updates.missed-update-message': '最新情報の投稿はありません',
  'project-content.project-content-updates.new-due-date': '新しい期限',
  'project-content.project-content-updates.new-state': '新しい状態',
  'project-content.project-content-updates.no-updates-description': 'このプロジェクトの最新情報はまだありません。',
  'project-content.project-content-updates.off-track': '遅延',
  'project-content.project-content-updates.old-due-date': '以前の期限',
  'project-content.project-content-updates.old-state': '以前の状態',
  'project-content.project-content-updates.on-track': '順調',
  'project-content.project-content-updates.paused': '一時停止中',
  'project-content.project-content-updates.pending': '保留中',
  'project-content.project-content-updates.previous-updates-title': '前の最新情報',
  'project-content.project-content-updates.share-update': '共有',
  'project-content.project-content-updates.status-changed': 'ステータスが変更されました',
  'project-content.project-content-updates.write-update-button': '最新情報を作成',
  'project-update-composer.modal-post-button-label': '最新情報を投稿',
  'project-update-composer.modal-title': '最新情報を投稿',
};
